import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {format} from 'date-fns/format';
import { of, Observable } from 'rxjs';

@Injectable()
export class DeliveryListService {
  constructor(private store: Store<any>) {}
  convertDate(dateToBeConverted: string) {
    if (!dateToBeConverted && !dateToBeConverted?.includes(' ')) {
      return '';
    }
    const curDate = dateToBeConverted?.split(' ')[0].replace(/-/g, '/');
    const date = format(new Date(curDate), 'MM/dd/yyyy');

    return date !== 'Invalid date' ? date : '';
  }

  setViewType(viewType: string) {
    localStorage.setItem('viewType', viewType);
  }

  getViewType(): Observable<string> {
    const viewType = localStorage.getItem('viewType') ?? 'list';
    return of(viewType);
  }
}
